import { Form } from 'react-bootstrap'
import PropTypes from 'prop-types'
import TooltipInfo from '../TooltipInfo.jsx'

export const LabelFor = (props) => {
    if (props?.label?.length > 0) {
        return (
            <div className={'float-start'}>
                <Form.Label
                    htmlFor={props.id}
                    className={'mb-0 group-label fw-bold w-100'}
                    column={null}
                >
                    {props.label}
                    <TooltipInfo text={props.tooltipText} />
                </Form.Label>
            </div>
        )
    } else {
        return <></>
    }
}

LabelFor.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    tooltipText: PropTypes.string,
}